import { createSlice } from "@reduxjs/toolkit";
import { fetchSummerPodcasts } from "./summerPodcastsActions";

const initialState = {
  podcasts: [],
  loading: false,
  error: null,
};

const summerPodcastsSlice = createSlice({
  name: "summerPodcasts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSummerPodcasts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSummerPodcasts.fulfilled, (state, action) => {
        state.loading = false;
        state.podcasts = Array.isArray(action.payload)
          ? action.payload
          : action.payload.results ?? [];
      })
      .addCase(fetchSummerPodcasts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const selectSummerPodcasts = (state) => state.summerPodcasts;
export default summerPodcastsSlice.reducer;
